import { useAppDispatch } from 'store';

export const usePositionConnection = () => {
    const dispatch = useAppDispatch();
    return {};
};
